(function () {
  if (window.__sxh) return;
  window.__sxh = 1;
  var root = document.documentElement;
  var saved = null;
  try { saved = localStorage.getItem('swx-theme'); } catch (e) {}
  root.setAttribute('data-swx-theme', saved === 'light' ? 'light' : 'dark');

  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function init() {
    var hdr = q('[data-sxh]');
    if (!hdr) return;
    var scrim = q('[data-sxh-scrim]');
    var items = qa('[data-sxh-mega]');
    var search = q('[data-sxh-searchbar]');
    var drawer = q('[data-sxh-drawer]');
    var openId = null, timer = null;

    function setH() { root.style.setProperty('--sxh-h', hdr.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH);
    if (window.ResizeObserver) new ResizeObserver(setH).observe(hdr);

    function hide(now) {
      var d = function () {
        qa('.sxh-mega').forEach(function (m) { m.classList.remove('show'); });
        items.forEach(function (i) { i.classList.remove('open'); i.setAttribute('aria-expanded', 'false'); });
        scrim.classList.remove('show');
        openId = null;
      };
      clearTimeout(timer);
      if (now) d(); else timer = setTimeout(d, 160);
    }
    function show(id, item) {
      if (openId && openId !== id) hide(true);
      clearTimeout(timer);
      if (search) search.classList.remove('show');
      var m = document.getElementById(id);
      if (!m) return;
      m.style.top = hdr.getBoundingClientRect().bottom + 'px';
      m.classList.add('show');
      scrim.classList.add('show');
      item.classList.add('open');
      item.setAttribute('aria-expanded', 'true');
      openId = id;
    }
    items.forEach(function (it) {
      var id = it.getAttribute('data-sxh-mega');
      var m = document.getElementById(id);
      it.addEventListener('mouseenter', function () { show(id, it); });
      it.addEventListener('mouseleave', function () { hide(); });
      it.addEventListener('click', function () { openId === id ? hide(true) : show(id, it); });
      if (m) {
        m.addEventListener('mouseenter', function () { clearTimeout(timer); });
        m.addEventListener('mouseleave', function () { hide(); });
      }
    });
    scrim.addEventListener('click', function () { hide(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(true); if (search) search.classList.remove('show'); if (drawer) drawer.classList.remove('show'); }
    });

    var sb = q('[data-sxh-search]');
    if (sb && search) sb.addEventListener('click', function () {
      hide(true);
      search.classList.toggle('show');
      if (search.classList.contains('show')) { var i = q('input[type=search]', search); if (i) setTimeout(function () { i.focus(); }, 120); }
    });

    var tg = q('[data-sxh-theme]');
    if (tg) tg.addEventListener('click', function () {
      var t = root.getAttribute('data-swx-theme') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-swx-theme', t);
      try { localStorage.setItem('swx-theme', t); } catch (e) {}
    });

    var bg = q('[data-sxh-burger]'), cl = q('[data-sxh-close]');
    if (bg && drawer) bg.addEventListener('click', function () { drawer.classList.add('show'); });
    if (cl && drawer) cl.addEventListener('click', function () { drawer.classList.remove('show'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function () {
  var acc = document.querySelector('[data-sxh-acc]');
  if (!acc || acc.__on) return;
  acc.__on = 1;
  var btn = acc.querySelector('[data-sxh-acc-btn]'), pop = acc.querySelector('[data-sxh-acc-pop]');
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var t;
  function open() {
    clearTimeout(t);
    if (acc.classList.contains('is-open')) return;
    pop.hidden = false;
    requestAnimationFrame(function () { acc.classList.add('is-open'); });
    btn.setAttribute('aria-expanded', 'true');
  }
  function close() {
    acc.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    t = setTimeout(function () { pop.hidden = true; }, 220);
  }
  btn.addEventListener('click', function (e) {
    if (fine && acc.classList.contains('is-open')) return;
    e.preventDefault();
    acc.classList.contains('is-open') ? close() : open();
  });
  if (fine) {
    acc.addEventListener('mouseenter', open);
    acc.addEventListener('mouseleave', function () { t = setTimeout(close, 180); });
  }
  document.addEventListener('click', function (e) { if (!acc.contains(e.target) && acc.classList.contains('is-open')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && acc.classList.contains('is-open')) { close(); btn.focus(); } });
})();
